export const roleTypes = [
	{value: 'admin', name: 'Administrador'},
]